export default "/assets/carrot.png";